import { IconPropTypes } from ".";

const copy = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.59995 13.3996L2.19995 13.3996C1.53721 13.3996 0.999951 12.8624 0.999951 12.1996L0.999953 3.39961C0.999954 2.29504 1.89538 1.39961 2.99995 1.39961L11.8 1.39961C12.4627 1.39961 13 1.93687 13 2.59961L13 4.99961M10.5999 20.5996L17.8 20.5996C19.1254 20.5996 20.2 19.5251 20.2 18.1996L20.2 10.9996C20.2 9.67413 19.1254 8.59961 17.8 8.59961L10.6 8.59961C9.27447 8.59961 8.19995 9.67413 8.19995 10.9996L8.19995 18.1996C8.19995 19.5251 9.27447 20.5996 10.5999 20.5996Z"
      stroke="#169FED"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const zoom = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9_2649)">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z"
        fill="#3984FD"
      />
      <path
        d="M5 9C5 8.44772 5.44772 8 6 8H12C13.6569 8 15 9.34315 15 11V15C15 15.5523 14.5523 16 14 16H8C6.34315 16 5 14.6569 5 13V9Z"
        fill="white"
      />
      <path
        d="M15.5 11.751C15.5 11.2666 15.6758 10.7986 15.9948 10.434L17.6856 8.50177C18.1416 7.98059 19 8.30312 19 8.99564V15.0035C19 15.696 18.1416 16.0185 17.6856 15.4973L15.9948 13.5651C15.6758 13.2005 15.5 12.7325 15.5 12.2481V11.751Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_2649">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const spin = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? 16}
    height={height ?? 16}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2,12A10.94,10.94,0,0,1,5,4.65c-.21-.19-.42-.36-.62-.55h0A11,11,0,0,0,12,23c.34,0,.67,0,1-.05C6,23,2,17.74,2,12Z"
    >
      <animateTransform
        attributeName="transform"
        dur="0.6s"
        repeatCount="indefinite"
        type="rotate"
        values="0 12 12;360 12 12"
      ></animateTransform>
    </path>
  </svg>
);

const menu = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="2"
      d="M21.6 19.2H2.4M21.6 12H2.4m19.2-7.2H2.4"
    ></path>
  </svg>
);

const close = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || "15"}
    height={height || "14"}
    fill="none"
    viewBox="0 0 15 14"
  >
    <path
      fill="#000"
      d="m14.199 1.917-1.35-1.35L7.493 5.92 2.14.566.79 1.917l5.353 5.354L.79 12.626l1.35 1.35 5.355-5.354 5.354 5.354 1.35-1.35L8.846 7.27z"
    ></path>
  </svg>
);

const left_arrow = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 7H4.33L9.92 1.41L8.5 0L0.5 8L8.5 16L9.91 14.59L4.33 9H16.5V7Z" fill="black" />
  </svg>
);
const updown = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="10px"
    width="18"
    height="18"
  >
    <path
      fillRule="evenodd"
      d="M11.47 4.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 6.31 8.78 9.53a.75.75 0 0 1-1.06-1.06l3.75-3.75Zm-3.75 9.75a.75.75 0 0 1 1.06 0L12 17.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06Z"
      clipRule="evenodd"
    />
  </svg>
);
const meet = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <rect width="16" height="16" x="12" y="16" fill="#fff" transform="rotate(-90 20 24)"></rect>
    <polygon fill="#1e88e5" points="3,17 3,31 8,32 13,31 13,17 8,16"></polygon>
    <path fill="#4caf50" d="M37,24v14c0,1.657-1.343,3-3,3H13l-1-5l1-5h14v-7l5-1L37,24z"></path>
    <path fill="#fbc02d" d="M37,10v14H27v-7H13l-1-5l1-5h21C35.657,7,37,8.343,37,10z"></path>
    <path fill="#1565c0" d="M13,31v10H6c-1.657,0-3-1.343-3-3v-7H13z"></path>
    <polygon fill="#e53935" points="13,7 13,17 3,17"></polygon>
    <polygon fill="#2e7d32" points="38,24 37,32.45 27,24 37,15.55"></polygon>
    <path
      fill="#4caf50"
      d="M46,10.11v27.78c0,0.84-0.98,1.31-1.63,0.78L37,32.45v-16.9l7.37-6.22C45.02,8.8,46,9.27,46,10.11z"
    ></path>
  </svg>
);
const Zoom = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <circle cx="24" cy="24" r="20" fill="#2196f3"></circle>
    <path fill="#fff" d="M29,31H14c-1.657,0-3-1.343-3-3V17h15c1.657,0,3,1.343,3,3V31z"></path>
    <polygon fill="#fff" points="37,31 31,27 31,21 37,17"></polygon>
  </svg>
);

const teams = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <path
      fill="#5059c9"
      d="M44,22v8c0,3.314-2.686,6-6,6s-6-2.686-6-6V20h10C43.105,20,44,20.895,44,22z M38,16	c2.209,0,4-1.791,4-4c0-2.209-1.791-4-4-4s-4,1.791-4,4C34,14.209,35.791,16,38,16z"
    ></path>
    <path
      fill="#7b83eb"
      d="M35,22v11c0,5.743-4.841,10.356-10.666,9.978C19.019,42.634,15,37.983,15,32.657V20h18	C34.105,20,35,20.895,35,22z M25,17c3.314,0,6-2.686,6-6s-2.686-6-6-6s-6,2.686-6,6S21.686,17,25,17z"
    ></path>
    <circle cx="25" cy="11" r="6" fill="#7b83eb"></circle>
    <path
      d="M26,33.319V20H15v12.657c0,1.534,0.343,3.008,0.944,4.343h6.374C24.352,37,26,35.352,26,33.319z"
      opacity=".05"
    ></path>
    <path
      d="M15,20v12.657c0,1.16,0.201,2.284,0.554,3.343h6.658c1.724,0,3.121-1.397,3.121-3.121V20H15z"
      opacity=".07"
    ></path>
    <path
      d="M24.667,20H15v12.657c0,0.802,0.101,1.584,0.274,2.343h6.832c1.414,0,2.56-1.146,2.56-2.56V20z"
      opacity=".09"
    ></path>
    <linearGradient
      id="DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1"
      x1="4.648"
      x2="23.403"
      y1="14.648"
      y2="33.403"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="#5961c3"></stop>
      <stop offset="1" stop-color="#3a41ac"></stop>
    </linearGradient>
    <path
      fill="url(#DqqEodsTc8fO7iIkpib~Na_zQ92KI7XjZgR_gr1)"
      d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"
    ></path>
    <path fill="#fff" d="M18.068,18.999H9.932v1.72h3.047v8.28h2.042v-8.28h3.047V18.999z"></path>
  </svg>
);
const external = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <path d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 12 L 19 12 L 19 19 L 5 19 L 5 5 L 12 5 L 12 3 L 5 3 z M 14 3 L 14 5 L 17.585938 5 L 8.2929688 14.292969 L 9.7070312 15.707031 L 19 6.4140625 L 19 10 L 21 10 L 21 3 L 14 3 z"></path>
  </svg>
);
const edit = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 32 32"
  >
    <path d="M 23.90625 3.96875 C 22.859375 3.96875 21.8125 4.375 21 5.1875 L 5.1875 21 L 5.125 21.3125 L 4.03125 26.8125 L 3.71875 28.28125 L 5.1875 27.96875 L 10.6875 26.875 L 11 26.8125 L 26.8125 11 C 28.4375 9.375 28.4375 6.8125 26.8125 5.1875 C 26 4.375 24.953125 3.96875 23.90625 3.96875 Z M 23.90625 5.875 C 24.410156 5.875 24.917969 6.105469 25.40625 6.59375 C 26.378906 7.566406 26.378906 8.621094 25.40625 9.59375 L 24.6875 10.28125 L 21.71875 7.3125 L 22.40625 6.59375 C 22.894531 6.105469 23.402344 5.875 23.90625 5.875 Z M 20.3125 8.71875 L 23.28125 11.6875 L 11.1875 23.78125 C 10.53125 22.5 9.5 21.46875 8.21875 20.8125 Z M 6.9375 22.4375 C 8.136719 22.921875 9.078125 23.863281 9.5625 25.0625 L 6.28125 25.71875 Z"></path>
  </svg>
);
const add = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <path
      fillRule="evenodd"
      d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z"
    ></path>
  </svg>
);
const calendar = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    style={{ cursor: "pointer" }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1C8.55229 1 9 1.44772 9 2V3.00228C9.29723 2.99999 9.61798 3 9.96449 3H14.0355C14.382 3 14.7028 2.99999 15 3.00228V2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2V3.12459C17.3192 3.17902 17.621 3.25947 17.9134 3.3806C19.1386 3.88807 20.1119 4.86144 20.6194 6.08658C20.8305 6.59628 20.9181 7.13456 20.9596 7.74331C21 8.33531 21 9.06272 21 9.96448V13.6035C21 14.7056 21 15.5944 20.9403 16.3138C20.8788 17.0547 20.7487 17.7049 20.4371 18.3049C19.9627 19.2181 19.2181 19.9627 18.3049 20.4371C17.7049 20.7487 17.0547 20.8788 16.3138 20.9403C15.5944 21 14.7056 21 13.6035 21H10.3965C9.29444 21 8.40557 21 7.68616 20.9403C6.94535 20.8788 6.29513 20.7487 5.69513 20.4371C4.78191 19.9627 4.03731 19.2181 3.56293 18.3049C3.25126 17.7049 3.12125 17.0547 3.05972 16.3138C2.99998 15.5944 2.99999 14.7056 3 13.6035V9.96449C2.99999 9.06273 2.99999 8.33531 3.04038 7.74331C3.08191 7.13456 3.16948 6.59628 3.3806 6.08658C3.88807 4.86144 4.86144 3.88807 6.08658 3.3806C6.37901 3.25947 6.68085 3.17902 7 3.12459V2C7 1.44772 7.44772 1 8 1ZM7 5.17476C6.94693 5.19142 6.89798 5.20929 6.85195 5.22836C6.11687 5.53284 5.53284 6.11687 5.22836 6.85195C5.135 7.07733 5.07033 7.37254 5.03574 7.87945C5.01452 8.19046 5.0059 8.55351 5.00239 9H18.9976C18.9941 8.55351 18.9855 8.19046 18.9643 7.87945C18.9297 7.37254 18.865 7.07733 18.7716 6.85195C18.4672 6.11687 17.8831 5.53284 17.1481 5.22836C17.102 5.20929 17.0531 5.19142 17 5.17476V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V5.00239C14.7059 5.00009 14.3755 5 14 5H10C9.62448 5 9.29413 5.00009 9 5.00239V6C9 6.55228 8.55229 7 8 7C7.44772 7 7 6.55228 7 6V5.17476ZM19 11H5V13.56C5 14.7158 5.0008 15.5214 5.05286 16.1483C5.10393 16.7632 5.19909 17.116 5.33776 17.3829C5.62239 17.9309 6.06915 18.3776 6.61708 18.6622C6.88403 18.8009 7.23678 18.8961 7.85168 18.9471C8.47856 18.9992 9.28423 19 10.44 19H13.56C14.7158 19 15.5214 18.9992 16.1483 18.9471C16.7632 18.8961 17.116 18.8009 17.3829 18.6622C17.9309 18.3776 18.3776 17.9309 18.6622 17.3829C18.8009 17.116 18.8961 16.7632 18.9471 16.1483C18.9992 15.5214 19 14.7158 19 13.56V11ZM13 16C13 15.4477 13.4477 15 14 15H16C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17H14C13.4477 17 13 16.5523 13 16Z"
      fill="#0F1729"
    />
  </svg>
);
const Home = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <path
      className={props.className}
      d="M39.5,43h-9c-1.381,0-2.5-1.119-2.5-2.5v-9c0-1.105-0.895-2-2-2h-4c-1.105,0-2,0.895-2,2v9c0,1.381-1.119,2.5-2.5,2.5h-9	C7.119,43,6,41.881,6,40.5V21.413c0-2.299,1.054-4.471,2.859-5.893L23.071,4.321c0.545-0.428,1.313-0.428,1.857,0L39.142,15.52	C40.947,16.942,42,19.113,42,21.411V40.5C42,41.881,40.881,43,39.5,43z"
    ></path>
  </svg>
);

const Lessons = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    viewBox="0 0 16.933333 21.1666675"
    version="1.1"
    x="0px"
    y="0px"
    height={height}
    width={width}
  >
    <g>
      <path
        className={props.className}
        d="m 6.6724616,3.8739227 c -0.483704,0 -0.882633,0.395646 -0.882633,0.879017 v 2.941422 h 1.230416 c 0.820491,0 1.501717,0.672282 1.501717,1.496033 0,0.8236363 -0.681146,1.4960333 -1.501717,1.4960333 h -1.002006 v 0.543636 c 0.162101,0.179116 0.39608,0.292488 0.654223,0.292488 h 8.5839734 c 0.483705,0 0.88315,-0.397712 0.88315,-0.881083 V 4.7529397 c 0,-0.483371 -0.399445,-0.879017 -0.88315,-0.879017 z m -3.53105,1.107426 c -0.814908,0 -1.482597,0.662188 -1.482597,1.474846 0,0.812658 0.667689,1.476395 1.482597,1.476395 0.814908,0 1.48208,-0.663737 1.48208,-1.476395 0,-0.812658 -0.667172,-1.474846 -1.48208,-1.474846 z m -0.90072,3.24218 c -0.796557,0 -1.44694097,0.645311 -1.44694097,1.439705 v 3.1305583 a 0.26460996,0.26460996 0 0 0 0.26354997,0.265617 h 4.166154 a 0.26460996,0.26460996 0 0 0 0.265617,-0.265617 v -2.636531 h 1.531173 c 0.533012,0 0.97255,-0.4344783 0.97255,-0.9668663 0,-0.532391 -0.439708,-0.966866 -0.97255,-0.966866 h -2.97863 -0.630969 z"
      />
    </g>
  </svg>
);
const Schedule = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 48 48"
  >
    <path
      className={props.className}
      d="M24,4C12.972,4,4,12.972,4,24s8.972,20,20,20s20-8.972,20-20S35.028,4,24,4z M28.561,30.561	C28.268,30.854,27.884,31,27.5,31s-0.768-0.146-1.061-0.439l-5-5C21.158,25.279,21,24.898,21,24.5v-11c0-0.829,0.671-1.5,1.5-1.5	s1.5,0.671,1.5,1.5v10.379l4.561,4.561C29.146,29.025,29.146,29.975,28.561,30.561z"
    ></path>
  </svg>
);

const Availability = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      className={props.className}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1C8.55229 1 9 1.44772 9 2V3.00228C9.29723 2.99999 9.61798 3 9.96449 3H14.0355C14.382 3 14.7028 2.99999 15 3.00228V2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2V3.12459C17.3192 3.17902 17.621 3.25947 17.9134 3.3806C19.1386 3.88807 20.1119 4.86144 20.6194 6.08658C20.8305 6.59628 20.9181 7.13456 20.9596 7.74331C21 8.33531 21 9.06272 21 9.96448V13.6035C21 14.7056 21 15.5944 20.9403 16.3138C20.8788 17.0547 20.7487 17.7049 20.4371 18.3049C19.9627 19.2181 19.2181 19.9627 18.3049 20.4371C17.7049 20.7487 17.0547 20.8788 16.3138 20.9403C15.5944 21 14.7056 21 13.6035 21H10.3965C9.29444 21 8.40557 21 7.68616 20.9403C6.94535 20.8788 6.29513 20.7487 5.69513 20.4371C4.78191 19.9627 4.03731 19.2181 3.56293 18.3049C3.25126 17.7049 3.12125 17.0547 3.05972 16.3138C2.99998 15.5944 2.99999 14.7056 3 13.6035V9.96449C2.99999 9.06273 2.99999 8.33531 3.04038 7.74331C3.08191 7.13456 3.16948 6.59628 3.3806 6.08658C3.88807 4.86144 4.86144 3.88807 6.08658 3.3806C6.37901 3.25947 6.68085 3.17902 7 3.12459V2C7 1.44772 7.44772 1 8 1ZM7 5.17476C6.94693 5.19142 6.89798 5.20929 6.85195 5.22836C6.11687 5.53284 5.53284 6.11687 5.22836 6.85195C5.135 7.07733 5.07033 7.37254 5.03574 7.87945C5.01452 8.19046 5.0059 8.55351 5.00239 9H18.9976C18.9941 8.55351 18.9855 8.19046 18.9643 7.87945C18.9297 7.37254 18.865 7.07733 18.7716 6.85195C18.4672 6.11687 17.8831 5.53284 17.1481 5.22836C17.102 5.20929 17.0531 5.19142 17 5.17476V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V5.00239C14.7059 5.00009 14.3755 5 14 5H10C9.62448 5 9.29413 5.00009 9 5.00239V6C9 6.55228 8.55229 7 8 7C7.44772 7 7 6.55228 7 6V5.17476ZM19 11H5V13.56C5 14.7158 5.0008 15.5214 5.05286 16.1483C5.10393 16.7632 5.19909 17.116 5.33776 17.3829C5.62239 17.9309 6.06915 18.3776 6.61708 18.6622C6.88403 18.8009 7.23678 18.8961 7.85168 18.9471C8.47856 18.9992 9.28423 19 10.44 19H13.56C14.7158 19 15.5214 18.9992 16.1483 18.9471C16.7632 18.8961 17.116 18.8009 17.3829 18.6622C17.9309 18.3776 18.3776 17.9309 18.6622 17.3829C18.8009 17.116 18.8961 16.7632 18.9471 16.1483C18.9992 15.5214 19 14.7158 19 13.56V11ZM13 16C13 15.4477 13.4477 15 14 15H16C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17H14C13.4477 17 13 16.5523 13 16Z"
      fill="#0F1729"
    />
  </svg>
);
const Message = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0,0,256,256"
  >
    <g
    // fill="#1a1a1a"
    // fill-rule="nonzero"
    // stroke="none"
    // stroke-width="1"
    // stroke-linecap="butt"
    // stroke-linejoin="miter"
    // stroke-miterlimit="10"
    // stroke-dasharray=""
    // stroke-dashoffset="0"
    // font-family="none"
    // font-weight="none"
    // fontSize="none"
    // text-anchor="none"
    >
      <g transform="scale(5.33333,5.33333)">
        <path
          className={props.className}
          d="M24,4c-11.028,0 -20,8.972 -20,20c0,3.186 0.77,6.343 2.232,9.172l-2.139,7.657c-0.242,0.867 0.003,1.802 0.64,2.439c0.475,0.475 1.115,0.732 1.771,0.732c0.224,0 0.449,-0.03 0.67,-0.092l7.661,-2.139c2.827,1.461 5.982,2.231 9.165,2.231c11.028,0 20,-8.972 20,-20c0,-11.028 -8.972,-20 -20,-20z"
        ></path>
      </g>
    </g>
  </svg>
);
const Profile = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="-5.0 -10.0 110.0 135.0"
    height={height}
    width={width}
  >
    <path
      className={props.className}
      d="m64.176 18.438c-12.598-12.594-34.223-3.6289-34.223 14.176 0 17.805 21.625 26.77 34.219 14.176 7.832-7.8281 7.832-20.523 0.003906-28.352zm-1.668 35.086c11.414 3.6406 21.371 12.871 21.371 24.988 0 4.3672 0.03125 8.9336-5.082 8.9336h-57.594c-5.1133 0-5.082-4.5664-5.082-8.9336 0-12.121 9.957-21.352 21.371-24.988 7.6836 4.6055 17.332 4.6094 25.016 0z"
      fillRule="evenodd"
    />
  </svg>
);
const Logout = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="-5.0 -10.0 110.0 135.0"
    height={height}
    width={width}
  >
    <path
      className={props.className}
      d="m39.062 90.594c0 1.7188-1.4062 3.125-3.125 3.125h-14.062c-8.625 0-15.625-7-15.625-15.625v-56.25c0-8.625 7-15.625 15.625-15.625h14.062c1.7188 0 3.125 1.4062 3.125 3.125s-1.4062 3.125-3.125 3.125h-14.062c-5.1562 0-9.375 4.2188-9.375 9.375v56.25c0 5.1562 4.2188 9.375 9.375 9.375h14.062c1.7188 0 3.125 1.4062 3.125 3.125zm54.688-40.594c0-2.5-0.96875-4.8438-2.75-6.625l-17.875-17.844c-1.2188-1.2188-3.1875-1.2188-4.4062 0s-1.2188 3.1875 0 4.4062l16.969 16.969h-61.094c-1.7188 0-3.125 1.4062-3.125 3.125s1.4062 3.125 3.125 3.125h61.031l-16.938 16.938c-1.2188 1.2188-1.2188 3.1875 0 4.4062 0.625 0.625 1.4062 0.90625 2.2188 0.90625s1.5938-0.3125 2.2188-0.90625l17.875-17.875c1.75-1.75 2.7188-4.0938 2.75-6.5938z"
    />
  </svg>
);
const eye = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    height={height}
    width={width}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);
const eyeSlash = ({ width, height, ...props }: IconPropTypes) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    height={height}
    width={width}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
    />
  </svg>
);

export const check = ({ height, width }: IconPropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#008000"
      height={height}
      width={width}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
    </svg>
  );
};

export type IconType = keyof typeof Icons;

const Icons = {
  copy,
  zoom,
  spin,
  menu,
  close,
  left_arrow,
  updown,
  meet,
  Zoom,
  teams,
  external,
  edit,
  add,
  calendar,
  Home,
  Lessons,
  Schedule,
  Availability,
  Message,
  Profile,
  Logout,
  eye,
  eyeSlash,
  check,
};
export default Icons;
